module.exports = __webpack_public_path__ + "static/img/b31.6198755.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b31.jpg
// module id = 5s/V
// module chunks = 1